import { render, staticRenderFns } from "./EllipsisTitle.vue?vue&type=template&id=29ea57d8&scoped=true&"
import script from "./EllipsisTitle.vue?vue&type=script&lang=js&"
export * from "./EllipsisTitle.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisTitle.vue?vue&type=style&index=0&id=29ea57d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ea57d8",
  null
  
)

export default component.exports